import { render } from "./TanaoroshiReaderPage.vue?vue&type=template&id=d053c77c&scoped=true"
import script from "./TanaoroshiReaderPage.vue?vue&type=script&lang=js"
export * from "./TanaoroshiReaderPage.vue?vue&type=script&lang=js"

import "./TanaoroshiReaderPage.vue?vue&type=style&index=0&id=d053c77c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3094357117/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d053c77c"]])

export default __exports__